import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { LinkCell } from 'core/elements';
import { formatDate } from 'core/utils';
import { elementTemplateDetailsPath } from 'elements/routes';
import { IElementTemplate } from 'elements/types';

import { ActionsCell } from './cells';
import { ElementTemplateListColId } from './enums';

export const columnDef = (): ColDef[] => [
  {
    colId: ElementTemplateListColId.CUSTOM_IDENTIFIER,
    headerName: t('headerIdentifier'),
    field: 'customIdentifier',
    filter: 'agTextColumnFilter',
    flex: 1,
    minWidth: 150,
    cellRenderer: 'agGroupCellRenderer',
    cellRendererParams: {
      innerRenderer: LinkCell,
      innerRendererParams: {
        getPath: (data: IElementTemplate) => elementTemplateDetailsPath(data.id),
        sx: { fontWeight: 'bold' },
      },
    },
  },
  {
    colId: ElementTemplateListColId.DESCRIPTION,
    headerName: t('headerDescription'),
    field: 'description',
    filter: 'agTextColumnFilter',
    flex: 2,
    minWidth: 200,
  },
  {
    colId: ElementTemplateListColId.OWNER,
    headerName: t('headerOwner'),
    field: 'ownerCorporateUserName',
    filter: 'agTextColumnFilter',
    flex: 1,
    minWidth: 150,
  },
  {
    colId: ElementTemplateListColId.UPDATED_AT,
    headerName: t('headerUpdated'),
    field: 'updatedAt',
    filter: 'agDateColumnFilter',
    valueFormatter: ({ value }) => formatDate(value),
    flex: 1,
    minWidth: 150,
  },
  {
    colId: ElementTemplateListColId.UPDATED_BY,
    headerName: t('headerUpdatedBy'),
    field: 'updatedByCorporateUserName',
    filter: 'agTextColumnFilter',
    flex: 1,
    minWidth: 150,
  },
  {
    colId: ElementTemplateListColId.ACTIONS,
    width: 250,
    maxWidth: 250,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    suppressColumnsToolPanel: true,
    suppressHeaderMenuButton: true,
    suppressMovable: true,
    enableRowGroup: false,
    pinned: 'right',
    lockPinned: true,
    cellClass: 'noDecorationCell',
  },
];
